import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function getInspectionTask
 * @desc 获取检查任务
 * @returns {Object}
 */
function getInspectionTask(params) {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/tasks?as=select
  `,
  { params } )
    .then(checkResponse);
}

/**
 * @function getTaskReady 获取是否可以新建任务
 * @returns {Boolean}  data.result
 */
const getTaskReady = () => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/is_ready`)
    .then(checkResponse)
}

/**
 * @function getTaskDetailData 获取任务详情信息
 * @returns {Object}  res.data 任务详情
 */
const getTaskDetailData = (id) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/tasks/${id}`)
    .then(checkResponse)
}

/**
 * @function postData 新建任务
 * @param {Object} data {title: 任务名称, deadline: 截止时间, config: 配置}
 * @returns {Object}  task {id: 任务 id}
 */
const getTaskPostData = (data) => {
  return axios
    .post(`/api/v1/projects/${getProjectId()}/tasks`, data)
    .then(checkResponse)
}

/**
 * @function putData 新建任务
 * @param {Number} id 任务 id
 * @param {Object} data 详情信息
 * @returns {Object} res.data 详情
 */
const getTaskPutData = (id, data) => {
  return axios
    .put(`/api/v1/projects/${getProjectId()}/tasks/${id}`, { data })
    .then(checkResponse)
}

/**
 * @function getTaskList 获取任务列表
 * @param {Number} page 页码
 * @param {Number} per 每页显示条数
 * @returns {Object} taskList {columns: 表头, data: 数据}
 */
const getTaskList = (page = 1, per = 10) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/tasks?datetime_format=datetime&page=${page}&per=${per}`
    )
    .then(checkResponse)
}

/**
 * @function getSearchtask 查询任务列表
 * @param {String} title  任务名称
 * @param {Array} time 时间
 * @returns {Object} taskList {columns: 表头, data: 数据}
 */
const getSearchtask = (title, time = null) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/tasks?datetime_format=datetime&title.like=${title}${
        time ? `&createdAt[timeGt]=${time[0]}&createdAt[timeLt]=${time[1]}` : ''
      }`
    )
    .then(checkResponse)
}

/**
 * @function getDispatchUser 获取用户是否可见
 * @param {Number}  id  任务id
 * @returns {Object} res.data {userId:  用户 id, isUsed:  是否可见}
 */
const getTaskDispatchUser = (id) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/tasks/detail?task_id=${id}`)
    .then(checkResponse)
}

/**
 * @function putDispatchData 修改分配检查员和点位的模式
 * @param {Number}  id  任务id
 * @param {Number}  range  模式
 * @param {Array} users 可见的 user_id
 */
const putTaskDispatchData = (id, range, users = null) => {
  return axios
    .put(
      `/api/v1/projects/${getProjectId()}/tasks/range?task_id=${id}&range=${range}`,
      users && { user_ids: users }
    )
    .then(checkResponse)
}

/**
 * @function getTaskSelect 获取所有任务名称
 * @returns {Object} task.data
 */
const getTaskSelect = () => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/tasks?view=selects&only=data`)
    .then(checkResponse)
}

/**
 * @function confirmTaskImport 确认导入
 * @param {Number} id 任务 id
 */
const confirmTaskImport = (id) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/connection/import/confirmImport?taskId=${id}`
    )
    .then(checkResponse)
}

/**
 * @function getTaskImportResult 确认导入
 * @param {Number} id 任务 id
 * @returns {Object} result
 */
const getTaskImportResult = (id) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/connection/import/importResult?taskId=${id}`
    )
    .then(checkResponse)
}

const getTaskTableData = (id) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/tasks/${id}/inpsector_details`
    )
    .then(checkResponse)
}

const putTaskAllot = (id, data) => {
  return axios
    .put(`/api/v1/projects/${getProjectId()}/tasks/${id}/allot`, data)
    .then(checkResponse)
}

const getAreaAndRoleTask = (id) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/tasks/${id}/details_with_user`)
    .then(checkResponse)
}

const putTaskConfig = (id,data) => {
  return axios
    .put(`/api/v1/projects/${getProjectId()}/tasks/${id}/config_switch`,data)
    .then(checkResponse)
}
const deleteTask = (id) => {
  return axios
    .delete(`/api/v1/projects/${getProjectId()}/tasks/${id}`)
    .then(checkResponse)
}
const createDLTask = (data) => {
  return axios
    .post(`/api/v1/projects/${getProjectId()}/tasks/dlljfl_random_task`, data)
    .then(checkResponse)
}

export {
  getTaskReady,
  getTaskDetailData,
  getTaskPostData,
  getTaskPutData,
  getTaskList,
  getTaskSelect,
  getSearchtask,
  getTaskDispatchUser,
  putTaskDispatchData,
  getInspectionTask,
  confirmTaskImport,
  getTaskImportResult,
  getTaskTableData,
  putTaskAllot,
  getAreaAndRoleTask,
  putTaskConfig,
  deleteTask,
  createDLTask
}
